module.exports = __webpack_public_path__ + "img/logo_ph.4c88974a.svg";